export const creditRequest = {
  creditTypo: { color: '#1B4960', fontWeight: '500' },
  pendingReviewBtn: { color: '#026EA1', fontWeight: '500' },
  approveBtn: { color: '#fff', fontWeight: '500' },
};
